const initialState = {
  name: '',
  amount: '',
  payer: undefined,
  payment_source: undefined,
  ui: {
    is_submitting: false,
    show: false
  },
}

export default function newTransactionForm(state=initialState, action){
  switch(action.type){
    case "UPDATE_NEW_TRANSACTION_UI":
     return {
        ...state,
        ui: {
          ...state.ui,
          ...action.payload,
        }
     }
    case "UPDATE_NEW_TRANSACTION_FIELD":
      return {
        ...state,
        ...action.payload
      }
    case "BEGIN_SUBMIT_NEW_TRANSACTION":
      return {
        ...state,
        ui: {
          ...state.ui,
          is_submitting: true
        }
      };
    case "SUCCESS_SUBMIT_NEW_TRANSACTION":
      return {
        ...initialState,
      };
    case "FAILED_NEW_TRANSACTION":
      return {
        ...state,
        errors: action.payload.errors
      };
    case "RESET_NEW_TRANSACTION_FORM":
      return initialState;
    default:
      return state
  }
}